import { useEffect, useRef } from 'react';
import { getPrivateCacheScope } from '../utils/privateCacheScope';
export default function useDetachedUploadRefresh(matches, refresh) {
  const handlers = useRef({matches, refresh}); handlers.current = {matches, refresh};
  useEffect(() => {
    const completed = event => {
      const detail = event.detail;
      if (detail?.detached && detail.scope === getPrivateCacheScope().scope && handlers.current.matches(detail)) handlers.current.refresh(detail.counts);
    };
    window.addEventListener('photos:upload-completed', completed);
    return () => window.removeEventListener('photos:upload-completed', completed);
  }, []);
}
